import { parseBeacon } from './beacon';
import churnZeroEventListener from './churnZeroEventListener';
import noflakeEventListener from './noflakeEventListener';

// interface PageViewEvent {
//   eventType: 'pageView';
//   user: User;
//   retailer: RetailerInfo;
//   eventType: 'pageView';
//   path: string;
//   pageTitle: string;
//   beacon?: BeaconAttributes;
// }
//
// interface ClickEvent {
//   eventType: 'click';
//   user: User;
//   retailer: RetailerInfo;
//   path: string;
//   pageTitle: string;
//   target: Element;
//   beacon?: BeaconAttributes;
// }

const eventListeners = [noflakeEventListener, churnZeroEventListener];

function trackEvent(event) {
  eventListeners.forEach(listener => {
    try {
      listener(event);
    } catch (e) {
      console.error('Error in event listener', e);
    }
  });
}

function trackPageView(user, retailer, path, beacon) {
  trackEvent({
    eventType: 'pageView',
    user,
    retailer,
    path,
    pageTitle: document.title,
    beacon,
  });
}

function trackButtonClick(user, retailer, path, event) {
  if (!(event.target instanceof HTMLElement)) return;

  const element = event.target.closest('button,a');
  if (!element) return;

  trackEvent({
    eventType: 'click',
    user,
    retailer,
    path,
    pageTitle: document.title,
    target: element,
    beacon: parseBeacon(element),
  });
}

export default { trackPageView, trackButtonClick };
